import { Injectable } from '@angular/core';
import { Faq, FaqSection } from 'src/types/graphql';

@Injectable()
export class FaqService {
  public section: FaqSection;
  public area: Faq;

  setArea(area: Faq) {
    this.area = area;
  }

  setSection(section: FaqSection) {
    this.section = section;
  }
}
